module.exports = __webpack_public_path__ + "static/media/left-img.fd8b52c2.png";